<template>
  <a-row :gutter="24">
    <a-col :span="24">
      <div
        style="width: 50%; margin: auto; /* 完整水平居中 */ line-height: 26px"
      >
        <a-form-model-item
          label="房屋状态"
          :label-col="{ span: 24 }"
          :wrapper-col="{ span: 24 }"
          prop="houseStatus"
        >
          <div style="padding-left: 30px; /* 缩进，让内容视觉居中 */">
            <a-radio-group v-model="form.houseStatus" :disabled="!isEditable">
              <a-radio style="margin: 4px 0px" value="1"
                >本标的房屋租赁合同已到期，房屋尚在使用中，若招租后发生移交纠纷，由出租方负责解决</a-radio
              >
              <br />
              <a-radio style="margin: 4px 0px" value="2"
                >本标的房屋尚在租赁合同期内，到期后由出租方负责落实资产交付相关事项</a-radio
              >
              <br />
              <a-radio style="margin: 4px 0px" value="3"
                >本标的房屋物业状态为空置</a-radio
              >
              <br />
              <div class="radio-line">
                <a-radio style="margin: 4px 0px" value="99">
                  <span class="radio-inline-wrap">
                    <span>其他</span>
                    <span
                      ><a-form-model-item
                        v-if="form.houseStatus == 99"
                        prop="housingStatusOtherDesc"
                        class="inline-form-item"
                      >
                        <a-input
                          v-model="form.housingStatusOtherDesc"
                          :disabled="!isEditable"
                          class="inline-input"
                          placeholder="请输入其他房屋状态说明"
                        /> </a-form-model-item
                    ></span>
                  </span>
                </a-radio>
              </div>
            </a-radio-group>
          </div>
        </a-form-model-item>
      </div>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="租赁面积" prop="leaseArea">
        <a-input
          v-model="form.leaseArea"
          placeholder="请输入租赁面积"
          :disabled="!isEditable"
        />
      </a-form-model-item>
    </a-col>
    <a-col :span="12" v-if="form.houseStatus == 2">
      <a-form-model-item label="租赁期限届满时间" prop="leaseExpireTime">
        <a-date-picker
          style="width: 100%"
          v-model="form.leaseExpireTime"
          :disabled="!isEditable"
          placeholder="请选择租赁期限届满时间"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-form-model-item label="租赁用途" prop="leaseUseType">
        <a-checkbox-group
          v-model="form.leaseUseType"
          style="width: 100%"
          :disabled="!isEditable"
        >
          <a-row :gutter="[0, 12]">
            <a-col
              :span="3"
              v-for="item in dictionaries.leaseUseType"
              :key="item.value"
            >
              <a-checkbox :value="item.value">{{ item.note }}</a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </a-form-model-item>
    </a-col>

    <a-col :span="24" v-if="form.leaseUseType.includes('16384')">
      <a-form-model-item label="其他租赁用途说明" prop="leaseUse">
        <a-input
          v-model="form.leaseUse"
          placeholder="请输入其他租赁用途说明"
          :disabled="!isEditable"
        />
      </a-form-model-item>
    </a-col>
  </a-row>
</template>

<script>
import { getHouseStatus, getLeaseUseType } from "@/api/shexgrp/Dictionaries.js";
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
    isEditable: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      fetching: {
        leaseUseType: false,
      },
      dictionaries: {
        leaseUseType: [
          {
            value: "1",
            note: "商业",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "2",
            note: "楼宇办公",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "8",
            note: "园区",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "16",
            note: "仓储",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "32",
            note: "厂房",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "64",
            note: "酒店",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "256",
            note: "住宅",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "512",
            note: "公寓",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "1024",
            note: "工业",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "2048",
            note: "农用",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "4096",
            note: "市政配套",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "8192",
            note: "场地",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "16384",
            note: "其他",
            classify: "ZLPT_ZLYT",
          },
        ],
      },
    };
  },
  methods: {
    //所属板块字典
    leaseUseTypeDictionaries() {
      // 已有数据则不再请求
      if (this.dictionaries.leaseUseType.length > 0) return;
      //获取字典内容
      this.fetching.leaseUseType = true;
      getLeaseUseType()
        .then((res) => {
          if (res && res.code === "200") {
            const list = res.data || [];
            this.dictionaries.leaseUseType = this.list;
          }
        })
        .catch((err) => {
          console.error("接口调用异常：", err);
        })
        .finally(() => {
          this.fetching.block = false;
        });
    },
  },
};
</script>

<style scoped>
/* 包住整句话 */
.radio-inline-wrap {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}
/* form-item 行内显示 */
.inline-form-item {
  display: inline-flex !important;
  align-items: center;
  margin: 0 8px !important;
}

/* 输入框统一规格 */
.inline-input {
  width: 300px;
  min-width: 100px;
  max-width: 400px;
  margin-top: 10px;
}
</style>